'use client'
import * as React from 'react';
import { Card } from './ui/card';
import { Separator } from './ui/separator';
import { ShimmerButton } from './ui/shimmer-button';
import { Spotlight } from './ui/spotlight';
import { FaDiscord, FaGithub, FaInstagram, FaLinkedin, FaTiktok, FaXTwitter, FaYoutube } from 'react-icons/fa6';
import Link from 'next/link';

const socials = [
    {
        name: 'X',
        src: 'https://x.com/fashn_ai',
        icon: FaXTwitter
    },
    {
        name: 'Instagram',
        src: 'https://www.instagram.com/fashn.ai/',
        icon: FaInstagram
    },
    {
        name: 'YouTube',
        src: 'https://www.youtube.com/@fashn_ai',
        icon: FaYoutube
    },
    {
        name: 'TikTok',
        src: 'https://www.tiktok.com/@fashn.ai',
        icon: FaTiktok
    },
    {
        name: 'LinkedIn',
        src: 'https://www.linkedin.com/company/fashn',
        icon: FaLinkedin
    },
    {
        name: 'Discord',
        src: 'https://discord.gg/MCs39Gf4yn',
        icon: FaDiscord
    },
    {
        name: 'GitHub',
        src: 'https://github.com/fashn-AI',
        icon: FaGithub
    }
]

export default function StartBanner({ showSocials }: { showSocials?: boolean }) {
    return (
        <section className="w-full lg:container pt-12 lg:px-0">

            <div className='py-10 px-4 flex flex-col gap-4 relative border border-primary w-fit mx-auto rounded-3xl mb-24 lg:mb-36'>
                <Spotlight
                    className="-top-40 left-0 md:left-60 md:-top-20"
                    fill="white"
                />
                <h1 className="text-4xl lg:text-6xl text-center leading-tight max-w-4xl mx-auto"><span className='opacity-60'>Start working with
                    the </span><span className='opacity-100'>best try-on technology</span>
                </h1>
                <div className="flex flex-col gap-1 items-center">
                    <Link
                        href="https://app.fashn.ai"
                        aria-label="Get started"
                        target='_blank'
                    >
                        <ShimmerButton className="w-fit px-10">
                            <span className="whitespace-pre-wrap text-center text-sm font-medium leading-none tracking-tight text-white dark:from-white dark:to-slate-900/10 lg:text-lg">
                                Get started for free
                            </span>
                        </ShimmerButton>
                    </Link>
                    <span className="text-xs opacity-60">No credit card required</span>
                </div>

            </div>
            {showSocials && <div className='bg-background py-4 px-6 rounded-t-2xl w-fit mx-auto'>
                <ul className='flex space-x-4 lg:space-x-6 items-center text-foreground/80'>
                    {socials.map((l) => (
                        <li key={l.name} className='group hover:text-foreground transition-all hover:-translate-y-1'>
                            <Link href={l.src} target='_blank'><l.icon className={'h-5 w-5 lg:h-8 lg:w-8'} /></Link>
                        </li>
                    ))}
                </ul>
            </div>}

        </section>
    )
}



